export const faEnvelopeDotDuotone = [
  '576 512',
  `<path opacity=".4" d="M32 112c0 15.1 7.1 29.3 19.2 38.4l208 156c17.1 12.8 40.5 12.8 57.6 0L456.3 201.7c-51.3-16.7-88.3-64.9-88.3-121.7 0-5.4 .3-10.8 1-16L80 64c-26.5 0-48 21.5-48 48zm0 84l0 188c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-185.3c-2.3 .9-4.7 1.8-7.1 2.6L345.6 344.8c-34.1 25.6-81.1 25.6-115.2 0L32 196z"/>
  <path d="M416 80a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"/>`
]
